/*
 * Header-Navigation: Hover-Intent + Sticky-Close + Keyboard-Support
 *
 *  - Steuerung erfolgt über die Klasse `.is-open` an <li> (anstelle von :hover).
 *  - Selektoren passen zur Klassenstruktur von Corporate.HermeticPumpenComm:Parts.Header
 *    (.header > .header-content > .header-nav > .header-nav-content > .header-nav-list).
 */

const SECOND_LEVEL_LIST = '.second-level-sub-navigation'
const SECOND_LEVEL_DROPDOWN = `${SECOND_LEVEL_LIST} > li.second-level-dropdown`

document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.header')
  if (!header) return

  const topItems = [...header.querySelectorAll('.header-nav-list > li')]
  const secondDropdownItems = [...header.querySelectorAll(SECOND_LEVEL_DROPDOWN)]

  // Tuning
  const OPEN_DELAY_TOP = 400
  const OPEN_DELAY_SECOND = 500
  const STICKY_DELAY_TOP = 400
  const STICKY_DELAY_SECOND = 500

  let activeTop = null
  let activeSecond = null

  let openTopTimer = null
  let openSecondTimer = null
  let stickyTopTimer = null
  let stickySecondTimer = null

  // ------------------------------------------------------------------
  // a11y
  // ------------------------------------------------------------------
  function setExpanded (li, expanded) {
    // Trigger kann <a>, <span role="button"> (Verweis-Seite/L2 mit Kindern) oder
    // <button> sein. Wir nehmen das erste matchende direkte Kind.
    const trigger = li.querySelector(':scope > .level1-link, :scope > .second-level-link, :scope > a, :scope > span[role="button"]')
    if (trigger) trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false')
  }

  // ------------------------------------------------------------------
  // Timer-Helper
  // ------------------------------------------------------------------
  function clearTimer (ref) {
    if (ref) clearTimeout(ref)
    return null
  }

  const cancelTopOpen = () => { openTopTimer = clearTimer(openTopTimer) }
  const cancelSecondOpen = () => { openSecondTimer = clearTimer(openSecondTimer) }
  const cancelTopSticky = () => { stickyTopTimer = clearTimer(stickyTopTimer) }
  const cancelSecondSticky = () => { stickySecondTimer = clearTimer(stickySecondTimer) }

  // ------------------------------------------------------------------
  // Open / Close primitives
  // ------------------------------------------------------------------
  function closeSecondImmediate () {
    cancelSecondOpen()
    cancelSecondSticky()
    if (!activeSecond) return
    activeSecond.classList.remove('is-open')
    setExpanded(activeSecond, false)
    activeSecond = null
  }

  function closeTopImmediate () {
    cancelTopOpen()
    cancelTopSticky()
    closeSecondImmediate()
    if (!activeTop) return
    activeTop.classList.remove('is-open')
    setExpanded(activeTop, false)
    activeTop = null
  }

  function scheduleStickyCloseTop (expectedTop) {
    cancelTopSticky()
    stickyTopTimer = window.setTimeout(() => {
      if (activeTop && activeTop === expectedTop) closeTopImmediate()
    }, STICKY_DELAY_TOP)
  }

  function scheduleStickyCloseSecond (expectedSecond) {
    cancelSecondSticky()
    stickySecondTimer = window.setTimeout(() => {
      if (activeSecond && activeSecond === expectedSecond) closeSecondImmediate()
    }, STICKY_DELAY_SECOND)
  }

  function openTopImmediate (li) {
    if (!li || !li.querySelector('.second-level-sub-navigation')) return

    cancelTopSticky()
    cancelSecondSticky()

    if (activeTop && activeTop !== li) closeTopImmediate()

    li.classList.add('is-open')
    setExpanded(li, true)
    activeTop = li
  }

  function openSecondImmediate (li) {
    if (!li || !li.querySelector('.third-level--wrapper')) return

    cancelSecondSticky()
    cancelTopSticky()

    const parentTop = li.closest('.header-nav-list > li')
    if (parentTop) openTopImmediate(parentTop)

    if (activeSecond && activeSecond !== li) {
      activeSecond.classList.remove('is-open')
      setExpanded(activeSecond, false)
    }

    li.classList.add('is-open')
    setExpanded(li, true)
    activeSecond = li
  }

  // ------------------------------------------------------------------
  // Hover-Intent
  // ------------------------------------------------------------------
  function openTopWithIntent (li) {
    if (!li || !li.querySelector('.second-level-sub-navigation')) return

    cancelTopOpen()
    cancelTopSticky()

    const needsDelay = activeTop && activeTop !== li
    if (!needsDelay) return openTopImmediate(li)

    openTopTimer = window.setTimeout(() => {
      if (li.matches(':hover')) openTopImmediate(li)
    }, OPEN_DELAY_TOP)
  }

  function openSecondWithIntent (li) {
    if (!li || !li.querySelector('.third-level--wrapper')) return

    cancelSecondOpen()
    cancelSecondSticky()

    const needsDelay = activeSecond && activeSecond !== li
    if (!needsDelay) return openSecondImmediate(li)

    openSecondTimer = window.setTimeout(() => {
      if (li.matches(':hover')) openSecondImmediate(li)
    }, OPEN_DELAY_SECOND)
  }

  // Init
  topItems.forEach(li => setExpanded(li, false))
  secondDropdownItems.forEach(li => setExpanded(li, false))

  // ------------------------------------------------------------------
  // Maus
  // ------------------------------------------------------------------
  topItems.forEach((li) => {
    li.addEventListener('mouseenter', () => openTopWithIntent(li))

    li.addEventListener('mouseleave', () => {
      cancelTopOpen()
      if (activeTop === li) scheduleStickyCloseTop(li)
    })
  })

  secondDropdownItems.forEach((li) => {
    const thirdWrapper = li.querySelector('.third-level--wrapper')
    if (!thirdWrapper) return

    li.addEventListener('mouseenter', () => {
      cancelSecondSticky()
      openSecondWithIntent(li)
    })

    li.addEventListener('mouseleave', (e) => {
      cancelSecondOpen()
      const to = e.relatedTarget
      // Direkt ins 3rd-Level → nicht sticky-schließen
      if (to && (to === thirdWrapper || thirdWrapper.contains(to))) return
      if (activeSecond === li) scheduleStickyCloseSecond(li)
    })

    thirdWrapper.addEventListener('mouseenter', () => {
      cancelSecondSticky()
      cancelSecondOpen()
      openSecondImmediate(li)
    })

    thirdWrapper.addEventListener('mouseleave', (e) => {
      const to = e.relatedTarget
      if (to && li.contains(to)) return
      if (activeSecond === li) scheduleStickyCloseSecond(li)
    })
  })

  // Header verlassen → alles zu (kurze Verzögerung gegen versehentliches Schließen)
  let leaveTimer = null
  header.addEventListener('mouseleave', () => {
    leaveTimer = window.setTimeout(() => closeTopImmediate(), 150)
  })
  header.addEventListener('mouseenter', () => {
    clearTimeout(leaveTimer)
    cancelTopSticky()
    cancelSecondSticky()
  })

  // ------------------------------------------------------------------
  // Tastatur (Tab)
  // ------------------------------------------------------------------
  header.addEventListener('focusin', (e) => {
    cancelTopSticky()
    cancelSecondSticky()
    cancelTopOpen()
    cancelSecondOpen()

    const target = e.target
    const secondLi = target.closest && target.closest(SECOND_LEVEL_DROPDOWN)
    if (secondLi && header.contains(secondLi)) {
      openSecondImmediate(secondLi)
      return
    }

    const topLi = target.closest && target.closest('.header-nav-list > li')
    if (topLi && header.contains(topLi)) openTopImmediate(topLi)
  })

  header.addEventListener('focusout', (e) => {
    const to = e.relatedTarget
    if (!to || !header.contains(to)) {
      closeTopImmediate()
      return
    }

    if (activeSecond) {
      const thirdWrapper = activeSecond.querySelector('.third-level--wrapper')
      const stillInsideSecond = activeSecond.contains(to) || (thirdWrapper && thirdWrapper.contains(to))
      if (!stillInsideSecond) closeSecondImmediate()
    }

    if (activeTop && !activeTop.contains(to)) closeTopImmediate()
  })

  header.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return
    closeTopImmediate()
    const firstFocusable = header.querySelector('.header-nav-list > li > .level1-link, .header-nav-list > li > a')
    if (firstFocusable && typeof firstFocusable.focus === 'function') firstFocusable.focus()
  })
})

// ===================================================================
//  Mobile-Akkordeon (.dropdown-mobile)
// ===================================================================
document.addEventListener('DOMContentLoaded', () => {
  const mobileDropdowns = document.querySelectorAll('.dropdown-mobile')

  mobileDropdowns.forEach((item) => {
    item.addEventListener('click', (e) => {
      if (window.innerWidth >= 1200) return

      // Trigger dieses Dropdowns: L1-Label (span) ODER L2-Link mit Kindern.
      // Beide togglen mobil das Akkordeon, statt zu navigieren – wie Ebene 1.
      const isTrigger = !!e.target.closest('.level1-link') ||
        (item.classList.contains('second-level-dropdown') &&
          !!e.target.closest('.second-level-link') &&
          e.target.closest('.second-level-dropdown') === item)

      // Klick auf einen echten Link, der NICHT der Trigger ist → navigieren, nicht togglen
      if (e.target.closest('a') && !isTrigger) {
        e.stopPropagation()
        return
      }

      e.stopPropagation()

      // Trigger (Verweis-Seite/L1-Label/L2-mit-Kindern) soll nicht navigieren
      if (isTrigger) e.preventDefault()

      item.classList.toggle('open')
    })
  })
})

// ===================================================================
//  Mobile-Overlay schließen bei Klick auf einen Anker-Link
//
//  Zeigt ein Link auf der aktuellen Seite auf ein Fragment (`#anker`),
//  findet kein Seiten-Reload statt – das Bootstrap-Overlay
//  `#header-nav-content` bliebe offen und würde die Zielstelle
//  verdecken. Der Listener läuft in der Capture-Phase, damit er auch
//  dann greift, wenn die Akkordeon-Logik oben per `stopPropagation()`
//  die Bubbling-Phase abbricht.
//
//  Der native Sprung zum Anker darf NICHT parallel zum Schließen
//  laufen: `#header-nav-content` ist `position: static` und im
//  geöffneten Zustand ~680px hoch, der Browser berechnet die
//  Sprungposition also noch anhand der vollen Overlay-Höhe und landet
//  weit hinter dem Ziel. Daher `preventDefault()` + manuell erst nach
//  Abschluss der Collapse-Animation (`hidden.bs.collapse`) scrollen.
// ===================================================================
document.addEventListener('DOMContentLoaded', () => {
  const overlay = document.getElementById('header-nav-content')
  if (!overlay) return

  overlay.addEventListener('click', (e) => {
    if (window.innerWidth >= 1200) return

    const link = e.target.closest('a[href]')
    if (!link) return

    const href = link.getAttribute('href')
    if (!href || href.indexOf('#') === -1) return

    // Trigger-Links des mobilen Akkordeons (L2-Link mit Kindern)
    // navigieren nicht wirklich, sondern klappen nur auf/zu.
    const dropdownItem = link.closest('.dropdown-mobile')
    const isAccordionTrigger = dropdownItem &&
      dropdownItem.classList.contains('second-level-dropdown') &&
      link.classList.contains('second-level-link') &&
      link.closest('.second-level-dropdown') === dropdownItem
    if (isAccordionTrigger) return

    const jq = window.jQuery || window.$
    const hasBsCollapse = jq && typeof jq.fn.collapse === 'function'

    const url = new URL(href, window.location.href)
    const isSamePage = url.pathname === window.location.pathname
    const target = isSamePage ? document.getElementById(url.hash.slice(1)) : null

    if (target) {
      e.preventDefault()

      const scrollToTarget = () => {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' })
        if (window.history && window.history.pushState) window.history.pushState(null, '', href)
      }

      if (hasBsCollapse) {
        jq(overlay).one('hidden.bs.collapse', scrollToTarget)
        jq(overlay).collapse('hide')
      } else {
        overlay.classList.remove('show')
        scrollToTarget()
      }
      return
    }

    if (hasBsCollapse) {
      jq(overlay).collapse('hide')
    } else {
      overlay.classList.remove('show')
    }
  }, true)
})

// ===================================================================
//  Sprach-/Länder-Menü Toggle
//  Jede `.utility-language`-Gruppe (Desktop-Utility-Bar + Mobile im
//  Burger-Menü) bekommt ihren eigenen Toggle: Klick auf
//  .utility-link--language togglet die `is-open`-Klasse auf der
//  zugehörigen .language-menu. Klick außerhalb / Escape schließen.
// ===================================================================
document.addEventListener('DOMContentLoaded', () => {
  const groups = document.querySelectorAll('.utility-language')
  if (!groups.length) return

  const OPEN_CLASS = 'is-open'
  const pairs = []

  groups.forEach((group) => {
    const trigger = group.querySelector('.utility-link--language')
    const menu = group.querySelector('.language-menu')
    if (!trigger || !menu) return

    const setOpen = (open) => {
      menu.classList.toggle(OPEN_CLASS, open)
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false')
    }

    // Initial geschlossen
    setOpen(false)

    trigger.addEventListener('click', (e) => {
      e.preventDefault()
      e.stopPropagation()
      setOpen(!menu.classList.contains(OPEN_CLASS))
    })

    // Expliziter Schließen-Button (X) im Panel (v. a. mobile Bottom-Sheet)
    const closeBtn = menu.querySelector('.language-menu__close')
    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()
        setOpen(false)
        trigger.focus()
      })
    }

    pairs.push({ trigger, menu, setOpen })
  })

  if (!pairs.length) return

  // Klick außerhalb schließt alle offenen Panels
  document.addEventListener('click', (e) => {
    pairs.forEach(({ trigger, menu, setOpen }) => {
      if (!menu.classList.contains(OPEN_CLASS)) return
      if (menu.contains(e.target) || trigger.contains(e.target)) return
      setOpen(false)
    })
  })

  // Escape schließt alle offenen Panels
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return
    pairs.forEach(({ trigger, menu, setOpen }) => {
      if (!menu.classList.contains(OPEN_CLASS)) return
      setOpen(false)
      trigger.focus()
    })
  })
})

// ===================================================================
//  Dynamische Positionierung des L2-/L3-Panels
//
//  Setzt CSS-Variablen `--header-height` und `--second-level-height`,
//  die im SCSS für `position: fixed; top: var(--header-height);` u. ä.
//  verwendet werden.
// ===================================================================
function updateNavOffsets () {
  const root = document.documentElement
  const header = document.querySelector('.header')
  if (header) {
    root.style.setProperty('--header-height', `${header.offsetHeight}px`)
  }

  const secondLevel = document.querySelector('.second-level-sub-navigation')
  if (secondLevel) {
    root.style.setProperty('--second-level-height', `${secondLevel.offsetHeight}px`)
  }
}

document.addEventListener('DOMContentLoaded', updateNavOffsets)
window.addEventListener('resize', updateNavOffsets)
window.addEventListener('load', updateNavOffsets)
